import React, { useEffect, useRef } from "react";
import IndexNavbar from "components/Navbars/IndexNavbar";
import FooterSmallNew from "components/Footers/FooterSmallNew";
import fg3 from "assets/img/gallery/fg3.jpg";
import fg5 from "assets/img/gallery/fg5.jpg";
import fg10 from "assets/img/gallery/fg10.jpg";
import fg13 from "assets/img/gallery/fg13.jpg";
import fg14 from "assets/img/gallery/fg14.webp";
import fg15 from "assets/img/gallery/fg15.jpg";
import fg20 from "assets/img/gallery/fg20.jpg";
import fg22 from "assets/img/gallery/fg22.jpg";
import fg23 from "assets/img/gallery/fg23.jpg";
import fg25 from "assets/img/gallery/fg25.jpg";
import fg26 from "assets/img/gallery/fg26.webp";
import fg29 from "assets/img/gallery/fg29.jpg";
import Footer from "components/Footers/Footer";
import bghome from "assets/img/bghome.jpg";
import IndexNavbar2 from "components/Navbars/IndexNavbar2";
import gallery from "assets/img/gallery.jpg";

const FoodGallery = () => {
  const imagesRef = useRef([]);
  imagesRef.current = [];

  const addToRefs = (el) => {
    if (el && !imagesRef.current.includes(el)) {
      imagesRef.current.push(el);
    }
  };

  useEffect(() => {
    const options = {
      threshold: 0.5,
    };

    const callback = (entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add("fade-in");
          }, index * 500); // Adjust the delay as needed
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);
    imagesRef.current.forEach((image) => observer.observe(image));

    return () => {
      imagesRef.current.forEach((image) => observer.unobserve(image));
    };
  }, []);

  return (
    <section>
      <IndexNavbar2 />
      {/* <section
        style={{
          backgroundImage: "url('https://i.ibb.co/SKCB8Gz/aboutusbanner.jpg')",
          backgroundColor: "#00244f",
          backgroundSize: "cover",
        }}
        className=""
      >
        <div className="bg-black-overlay">
          <div className="container xl:pt-60 lg:pt-52 md:pt-40 pt-52 xl:pb-44 lg:pb-32 md:pb-28 pb-32 mx-auto flex flex-wrap ">
            <div className="w-full center-items">
              <h1 className="xl:w-8/12 uppercase font-semibold banner-font text-white xl:text-head1 lg:text-head1 md:text-head1 text-head1 text-center">
                Gallery Mediterranee<span className="text-redd"></span>
              </h1>
            </div>
          </div>
        </div>
      </section> */}
      <section className="xl:pt-28 lg:pt-28 md:pt-17 pt-17"></section>
      <section
        style={{
          position: "relative",
          backgroundImage: `url(${gallery})`,
          // backgroundAttachment: "fixed",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className="xl:h-450 lg:h-300 md:h-300 justify-center text-white"
      >
        <div className="">
          <div className="container mx-auto overflow-hidden hometext xl:px-24 px-4">
            <div className="grid md:grid-cols-2 ">
              <div className="text-left bg-dark-blue xl:p-16 lg:p-14 md:p-12 p-12">
                <h1 className="banner-font text-white xl:pt-16 font-extrabold xl:text-head1 lg:text-head1 headlineheight md:text-head1 text-head1 md:text-xl text-2xl">
                  WE OFFER FIRST CLASS SEA FOOD
                </h1>
                <p className="pt-2 xl:pt-2 text-white xl:mb-18 banner-font xl:text-lg text-lg">
                  We guarantee you the best seafood, delivered daily to our
                  dock, prepared to your liking. Our focus is on serving the
                  absolute freshest fish and seafood.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="overflow-hidden">
          <div className="w-12/12 md:flex flex-none gap-1 xl:mt-12 mt-8">
            <div className="xl:w-6/12 lg:w-6/12 md:w-6/12">
              <img
                ref={addToRefs}
                alt="Your browser doe not supoort this image"
                src={fg20}
                className="w-full md:mt-0 mt-6 xl:h-90 lg:h-60 hidden-image"
              />
            </div>
            <div className="xl:w-3/12 lg:w-3/12 md:w-3/12">
              <img
                ref={addToRefs}
                src={fg26}
                className="md:mt-0 mt-2 h-full hidden-image"
                alt="Your browser doe not supoort this image"
              />
            </div>
            <div className="xl:w-3/12 lg:w-3/12 md:w-3/12">
              <img
                ref={addToRefs}
                src={fg3}
                className="md:mt-0 mt-2 w-full h-full hidden-image"
                alt="Your browser doe not supoort this image"
              />
            </div>
          </div>
          {/* second row  */}
          <div className="w-12/12 md:flex flex-none gap-1 xl:pt-1 pt-1">
            <div className="xl:w-3/12 lg:w-3/12 md:w-3/12 md:mt-0 mt-2">
              <img
                ref={addToRefs}
                src={fg5}
                className="h-full hidden-image"
                alt="Your browser doe not supoort this image"
              />
            </div>
            <div className="xl:w-3/12 lg:w-3/12 md:w-3/12">
              <img
                ref={addToRefs}
                src={fg23}
                className="h-full md:mt-0 mt-2 hidden-image"
                alt="Your browser doe not supoort this image"
              />
            </div>
            <div className="xl:w-6/12 lg:w-6/12 md:w-6/12">
              <img
                ref={addToRefs}
                src={fg22}
                className="w-full h-full md:mt-0 mt-2 hidden-image"
                alt="Your browser doe not supoort this image"
              />
            </div>
          </div>
          {/* third row  */}
          <div className="w-12/12 md:flex flex-none gap-1 xl:pb-0 xl:pt-1 pt-1">
            <div className="xl:w-6/12 lg:w-6/12 md:w-6/12">
              <img
                ref={addToRefs}
                src={fg14}
                className="w-full md:mt-0 mt-2 h-full hidden-image"
                alt="Your browser doe not supoort this image"
              />
            </div>
            <div className="xl:w-3/12 lg:w-3/12 md:w-3/12">
              <img
                ref={addToRefs}
                src={fg10}
                className="md:mt-0 mt-2 h-full hidden-image"
                alt="Your browser doe not supoort this image"
              />
            </div>
            <div className="xl:w-3/12 lg:w-3/12 md:w-3/12">
              <img
                ref={addToRefs}
                src={fg29}
                className="md:mt-0 mt-2 h-full hidden-image"
                alt="Your browser doe not supoort this image"
              />
            </div>
          </div>
          {/* fourth row  */}
          <div className="w-12/12 md:flex flex-none gap-1 xl:pb-12 pb-12 xl:pt-1 pt-1">
            <div className="xl:w-3/12 lg:w-3/12 md:w-3/12 md:mt-0 mt-2">
              <img
                ref={addToRefs}
                src={fg15}
                className="h-full hidden-image"
                alt="Your browser doe not supoort this image"
              />
            </div>
            <div className="xl:w-3/12 lg:w-3/12 md:w-3/12">
              <img
                ref={addToRefs}
                src={fg25}
                className="h-full md:mt-0 mt-2 hidden-image"
                alt="Your browser doe not supoort this image"
              />
            </div>
            <div className="xl:w-6/12 lg:w-6/12 md:w-6/12">
              <img
                ref={addToRefs}
                src={fg13}
                className="w-full h-full md:mt-0 mt-2 hidden-image"
                alt="Your browser doe not supoort this image"
              />
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <FooterSmallNew />
    </section>
  );
};

export default FoodGallery;
